module.exports = __webpack_public_path__ + "img/antes_despues_61.2244a5f6.png";